
/* styles */
require("!!../../../../../../azure/movemais.client/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../../azure/movemais.client/node_modules/vue-loader/lib/style-rewriter?id=data-v-7866cdb0&scoped=true!../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=styles&index=0!./modal-switch-plate.vue")

var Component = require("!../../../../../../azure/movemais.client/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=script&index=0!./modal-switch-plate.vue"),
  /* template */
  require("!!../../../../../../azure/movemais.client/node_modules/vue-loader/lib/template-compiler?id=data-v-7866cdb0!../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=template&index=0!./modal-switch-plate.vue"),
  /* scopeId */
  "data-v-7866cdb0",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/modal-switch-plate.vue
// module id = 1882
// module chunks = 1